// src/components/shared/ContinentTooltip.js
import React from 'react';

// Country.continent still holds legacy continental association codes; spell them out for users.
const CONTINENT_MEANINGS = {
  ANOCA: 'Association of National Olympic Committees of Africa',
  EOC: 'European Olympic Committees',
  OCA: 'Olympic Council of Asia',
  ONOC: 'Oceania National Olympic Committees',
  'Panam Sports': 'Pan American Sports Organisation',
};

// Tooltip for the read-only Continent field, shown on hover, focus or tap. Show it inside a `.field-tooltip-wrap` container;
// give the input aria-describedby={id} so screen readers announce it.
const ContinentTooltip = ({ continent, id }) => {
  const meaning = CONTINENT_MEANINGS[continent];
  return (
    <span className="field-tooltip" role="tooltip" id={id}>
      <strong className="field-tooltip-title">Continent</strong>
      <span className="field-tooltip-text">
        Filled in automatically from the Country you select. It can't be edited.
      </span>
      {!continent && (
        <span className="field-tooltip-extra">Select a country to see its continent.</span>
      )}
      {meaning && (
        <span className="field-tooltip-extra">
          {continent} = {meaning}
        </span>
      )}
    </span>
  );
};

export default ContinentTooltip;
